import "./Footer.css";

const Footer = () => (
  <footer>
    <div className="desktop-footer">
      <div className="blue-container">
        <div className="container">
          <div className="left-container">
            <div className="holcim-logo">
              <img
                src="/assets/logos/Holcim-WhiteLogo.svg"
                alt="Holcim Logo in White"
              />
            </div>
            <div className="text-buttons">
              <a href="https://www.holcim.com.mx/gobierno-corporativo">Cumplimiento Ético</a>
              <a href="https://www.holcim.com.mx/estrategia-2025">Estrategia 2025</a>
              <a href="https://www.holcim.com.mx/donde-estamos">Dónde estamos</a>
            </div>
            <div className="buttons">
              <a href="https://www.holcim.com.mx/contacto">
                <button>Contáctanos</button>
              </a>
              <div className="social-networks-buttons">
                <a href="https://www.linkedin.com/company/holcimmexico/" target="_blank" rel="noopener noreferrer">
                  <div className="icon-container">
                    <img src="/assets/icons/linkedin.svg" alt="linkedin logo" />
                  </div>
                </a>
                <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
                  <div className="icon-container">
                    <img src="/assets/icons/twitter.svg" alt="twitter logo" />
                  </div>
                </a>
                <a href="https://www.youtube.com/user/HolcimMexico" target="_blank" rel="noopener noreferrer">
                  <div className="icon-container">
                    <img src="/assets/icons/youtube.svg" alt="youtube logo" />
                  </div>
                </a>
                <a href="https://www.facebook.com/HolcimMexico/" target="_blank" rel="noopener noreferrer">
                  <div className="icon-container">
                    <img src="/assets/icons/facebook.svg" alt="facebook logo" />
                  </div>
                </a>
                <a href="https://www.instagram.com/holcimmexico/" target="_blank" rel="noopener noreferrer">
                  <div className="icon-container">
                    <img src="/assets/icons/instagram.svg" alt="instagram logo" />
                  </div>
                </a>
              </div>
            </div>

          </div>
          <div className="right-container">
            <div className="title">
              CONSTRUYENDO PROGRESO PARA LAS PERSONAS Y EL PLANETA
            </div>
            <div className="text">
              Como líder mundial en soluciones innovadoras y sostenibles para la
              construcción, Holcim está haciendo posible tener ciudades más
              verdes, infraestructuras más inteligentes y mejorar el nivel de
              vida de las personas en todo el mundo. Con la sostenibilidad al
              centro de su estrategia, Holcim se está convirtiendo en una
              empresa net-zero, en donde su gente y sus comunidades son la base
              de su éxito. La empresa está impulsando la construcción circular
              como líder mundial del reciclaje para construir más y mejor.
              <br /> <br />
              Holcim es la empresa que está detrás de algunas de las marcas más
              confiables del mundo en el sector de la construcción, como
              Disensa, PASA, INDAR, Elevate y Geocycle. Holcim cuenta con 60,000
              personas en todo el mundo que se apasionan por construir el
              progreso para las personas y el planeta a través de cuatro
              segmentos de negocio: Cemento, Concreto Premezclado, Agregados y
              Soluciones y Productos.
            </div>
          </div>
        </div>
      </div>
      <div className="white-container">
        <div className="text-container">
          <div className="text">© HOLCIM 2024</div>
          <div className="text-buttons">
            <a href="https://www.holcim.com.mx/sitemap" className="separator">
              Mapa del sitio
            </a>
            <a href="https://www.holcim.com.mx/contacto" className="separator">
              Contacto
            </a>
            <a href="https://www.holcim.com.mx/legal-notice" className="separator">
              Avisos de Privacidad
            </a>
            <a href="https://www.holcim.com.mx/cookie-policy">Política de Cookies</a>
          </div>
        </div>
        <div className="logo-container">
          <img
            src="/assets/logos/holcim_group_endorsement_spanish.png"
            alt="Logo Grupo Holcim"
            style={{ width: "170px" }}
          />
        </div>
      </div>
    </div>

    <div className="mobile-footer">
      <div className="blue-container">
        <img
          src="/assets/logos/Holcim-WhiteLogo.svg"
          alt="Holcim Logo in White"
        />
        <div className="title">
          CONSTRUYENDO PROGRESO PARA LAS PERSONAS Y EL PLANETA
        </div>
        <div className="text">
          Como líder mundial en soluciones innovadoras y sostenibles para la
          construcción, Holcim está haciendo posible tener ciudades más verdes,
          infraestructuras más inteligentes y mejorar el nivel de vida de las
          personas en todo el mundo. Con la sostenibilidad al centro de su
          estrategia, Holcim se está convirtiendo en una empresa net-zero, en
          donde su gente y sus comunidades son la base de su éxito. La empresa
          está impulsando la construcción circular como líder mundial del
          reciclaje para construir más y mejor.
          <br /> <br />
          Holcim es la empresa que está detrás de algunas de las marcas más
          confiables del mundo en el sector de la construcción, como Disensa,
          PASA, INDAR, Elevate y Geocycle. Holcim cuenta con 60,000 personas en
          todo el mundo que se apasionan por construir el progreso para las
          personas y el planeta a través de cuatro segmentos de negocio:
          Cemento, Concreto Premezclado, Agregados y Soluciones y Productos.
        </div>

        <div className="buttons">
          <a href="https://www.holcim.com.mx/contacto">
            <button>Contáctanos</button>
          </a>
          <div className="social-networks-buttons">
            <a href="https://www.linkedin.com/company/holcimmexico/" target="_blank" rel="noopener noreferrer">
              <div className="icon-container">
                <img src="/assets/icons/linkedin.svg" alt="linkedin logo" />
              </div>
            </a>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
              <div className="icon-container">
                <img src="/assets/icons/twitter.svg" alt="twitter logo" />
              </div>
            </a>
            <a href="https://www.youtube.com/user/HolcimMexico" target="_blank" rel="noopener noreferrer">
              <div className="icon-container">
                <img src="/assets/icons/youtube.svg" alt="youtube logo" />
              </div>
            </a>
            <a href="https://www.facebook.com/HolcimMexico/" target="_blank" rel="noopener noreferrer">
              <div className="icon-container">
                <img src="/assets/icons/facebook.svg" alt="facebook logo" />
              </div>
            </a>
            <a href="https://www.instagram.com/holcimmexico/" target="_blank" rel="noopener noreferrer">
              <div className="icon-container">
                <img src="/assets/icons/instagram.svg" alt="instagram logo" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="white-container">
        <div className="text">© HOLCIM 2024</div>
        <div className="text-buttons">
          <a href="https://www.holcim.com.mx/sitemap" className="separator">
            Mapa del sitio
          </a>
          <a href="https://www.holcim.com.mx/contacto" className="separator">
            Contacto
          </a>
          <a href="https://www.holcim.com.mx/legal-notice" className="separator">
            Avisos de Privacidad
          </a>
          <a href="https://www.holcim.com.mx/cookie-policy">Política de Cookies</a>
        </div>
        <div className="logo-container">
          <img
            src="/assets/logos/holcim_group_endorsement_spanish.png"
            alt="Logo Grupo Holcim"
            style={{ width: "170px" }}
          />
        </div>
      </div>
    </div>
  </footer>
);
export default Footer;
